import {UserDto} from '../../data-access/http/dto/user.dto'
import {User} from '../../models/user'

export class UserMapper {

  static dtoToModel(userDto: UserDto): User {
    if (!userDto) {
      return null
    }
    return {
      ...userDto,
      displayName: userDto.prenom + ' ' + userDto.nom,
      initiales: (userDto.prenom[0] + userDto.nom[0]).toUpperCase()
    }
  }


}
